module.exports = __webpack_public_path__ + "img/green-carpet-grass-04.45d668c7.png";